
















































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import pdf from "vue-pdf";
import Swal from 'sweetalert2'
import { applyTheme, ThemeConfig } from "@/helpers/themeHelper";

//const nav = navigator as any;
interface NavigatorShare extends Navigator {
    canShare?: (data?: { files?: File[] }) => boolean;
    share?: (data: { title?: string; text?: string; files?: File[] }) => Promise<void>;
}

//const nav = navigator as NavigatorShare;

@Component({
    components: { pdf },
})
export default class LabResults extends Vue {
    @Prop(String) readonly publicId!: string;
    @Prop() readonly visit!: any;
    private themeConfig: ThemeConfig | null = null;

    internalVisit: any = null;
    isDark = false;
    isMobile = false;
    canShareFile = false;

    previewFileUrl: string | null = null;
    previewFileName = "";
    previewVisible = false;
    page = 1;
    numPages = 0;
    scale = 1;

    lab = {
        name: "",
        showName:true,
        location: "",
        address: "",
        phone: "",
        clia: "",
        license: "",
    };

    patient = {
        name: "",
        accountNumber: "",
        requisitionNumber: "",
        birthDate: "",
        age: 0,
        gender: "",
        phone: "",
        email: "",
    };

    results: any[] = [];

    get currentLangLabel() {
        return this.$store.state.main.lang.toUpperCase() === "EN" ? "ES" : "EN";
    }

    toggleLanguage() {
        const newLang = this.$store.state.main.lang.toUpperCase() === "EN" ? "ES" : "EN";
        this.$store.commit("main/SET_LANG", newLang.toLowerCase());
        this.$i18n.locale = newLang.toLowerCase();
    }

    created() {
        this.isMobile = window.innerWidth <= 768;
        window.addEventListener("resize", () => (this.isMobile = window.innerWidth <= 768));

        //
         const visitFromRoute = this.$route.params.visit;

    if (visitFromRoute) {
        this.internalVisit = visitFromRoute;
        sessionStorage.setItem("visitData", JSON.stringify(visitFromRoute));
    } else {
        const visitFromStorage = sessionStorage.getItem("visitData");
        if (visitFromStorage) {
            this.internalVisit = JSON.parse(visitFromStorage);
            if (this.internalVisit.header.PublicID != this.publicId) {
                sessionStorage.removeItem("visitData");
                this.$router.replace({ name: "LabLogin" });
            }
        } else {
            this.$router.replace({ name: "LabLogin" });
            return;
        }
    }

        //
    }

    beforeDestroy() {
        window.removeEventListener("resize", () => (this.isMobile = window.innerWidth <= 768));
    }

    initData() {
        const visit = this.internalVisit;
        if (!visit || !visit.header) return;

        this.lab = {
            name: visit.header.EntityName,
            showName: visit.header.ShowEntityName,
            location: visit.header.FacilityLocationName ?? visit.header.LocationName,
            address: this.getFullAddress(visit),
            phone: visit.header.FacilityPhone ?? visit.header.LocationPhone,
            clia: visit.header.CLIA,
            license: visit.header.License,
        };

        this.patient = {
            name: this.getFullName(visit),
            accountNumber: visit.header.AccountNumber,
            requisitionNumber: visit.header.RequisitionNumber,
            birthDate: visit.header.BirthDateTime ? moment(visit.header.BirthDateTime).format("MM/DD/YYYY") : "",
            age: moment().diff(visit.header.BirthDateTime, "years"),
            gender: visit.header.NormalSex,
            phone: visit.header.HomePhone,
            email: visit.header.Email,
        };

        this.results = visit.files || [];
    }

    getFullName(visit) {
        if (!visit || !visit.header) return "";

        const { Name, FirstName, LastName } = visit.header;

        if (Name && Name.trim() !== "") {
            return Name.trim();
        }

        return [FirstName, LastName].filter(Boolean).join(" ").trim();
    }


    getFullAddress(visit: any): string {
        if (!visit || !visit.header) return "";

        if (visit.header.FacilityLocationName) {
            const { FacilityAddressLine1, FacilityAddressLine2, FacilityCity, FacilityState, FacilityZip } = visit.header;
            return [FacilityAddressLine1, FacilityAddressLine2, FacilityCity, FacilityState, FacilityZip]
                .filter((part) => part && part.trim() !== "")
                .join(", ");
        }

        const { LocationAddressLine1, LocationAddressLine2, LocationCity, LocationState, LocationZip } = visit.header;
        return [LocationAddressLine1, LocationAddressLine2, LocationCity, LocationState, LocationZip]
            .filter((part) => part && part.trim() !== "")
            .join(", ");
    }

    async getEntityLogo() {
        if (!this.internalVisit.header.EntityLogoID) return;
        const params = new FormData();
        params.append("id", this.internalVisit.header.EntityLogoID);
        const { data } = await Vue.axios.post("labs/content", params, {
            responseType: "blob",
        });
        const blob = new Blob([data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const logoEl = document.querySelector<HTMLImageElement>("#entity-logo");
        if (logoEl) {
            logoEl.src = url;
        }
    }
    async downloadFile(result) {

        try {
            this.$set(result, 'downloaded', false);
            this.$set(result, 'downloading', true);

            const url = '/labs/download'
            const form = new FormData()
            form.append('storageId', result.StorageID)

            const resp = await Vue.axios.post(url, form, {
                responseType: 'blob',
            })
            const filename = result.FileName;

            // 
            const blob = new Blob([resp.data])
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = filename
            document.body.appendChild(link)
            link.click()
            link.remove()
            URL.revokeObjectURL(link.href)

            this.$set(result, 'downloaded', true);

        } catch (err) {
            this.$set(result, 'downloaded', false);

            this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "AN ERROR HAS OCCURRED",
            });

            console.error('Download error', err)
        } finally {

            this.$set(result, 'downloading', false);

        }
    }

    async previewPdf(result: any) {
        try {
            if (!result.FileName.toLowerCase().endsWith(".pdf")) return;
            this.$set(result, "downloading", true);

            const url = "/labs/download";
            const form = new FormData();
            form.append("storageId", result.StorageID);

            const resp = await Vue.axios.post(url, form, { responseType: "blob" });
            const blob = new Blob([resp.data], { type: "application/pdf" });

            this.previewFileUrl = URL.createObjectURL(blob);
            this.previewFileName = result.FileName;
            this.previewVisible = true;
            this.page = 1; // Reset al abrir

        } catch (err) {
            console.error("Error generating preview", err);
            this.$modal.show("dialog", { title: "WaitingMed", text: "THE FILE COULD NOT BE PREVIEWED" });
        } finally {
            this.$set(result, "downloading", false);
        }
    }

   async downloadPreview() {
    if (!this.previewFileUrl || !this.previewFileName) return;

    try {
        const response = await fetch(this.previewFileUrl, {
            mode: "cors",
            credentials: "same-origin"
        });

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = this.previewFileName;

        // Safari iOS requires link to be in DOM
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        }, 500);

        // 🟢 SweetAlert de éxito
        Swal.fire({
            icon: "success",
            title: this.$t("File downloaded").toString(),
            text: this.$t("You can find it in your Downloads folder.").toString(),
            confirmButtonText: "OK"
        });

    } catch (err) {
        console.error("Download error:", err);

        Swal.fire({
            icon: "error",
            title: this.$t("Error downloading").toString(),
            text: this.$t("The file could not be downloaded. Please try again.").toString(),
            confirmButtonText: this.$t("Close").toString()
        });
    }
}



    downloadPreviewFunciona() {
        if (!this.previewFileUrl || !this.previewFileName) return;

        const link = document.createElement("a");
        link.href = this.previewFileUrl;
        link.download = this.previewFileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    closePreview() {
        if (this.previewFileUrl) URL.revokeObjectURL(this.previewFileUrl);
        this.previewFileUrl = null;
        this.previewVisible = false;
    }

    onNumPages(total: number) {
        this.numPages = total;
    }

    nextPage() {
        if (this.page < this.numPages) this.page++;
    }

    prevPage() {
        if (this.page > 1) this.page--;
    }

    initPreviewZoom() {
        this.isMobile = /Mobi|Android/i.test(navigator.userAgent);

        if (this.isMobile) {
            const container = this.$refs.pdfContainer as HTMLElement;
            if (container) {
                let startDist = 0;
                container.addEventListener("touchstart", (e: TouchEvent) => {
                    if (e.touches.length === 2) {
                        startDist = this.getTouchDist(e.touches);
                    }
                });
                container.addEventListener("touchmove", (e: TouchEvent) => {
                    if (e.touches.length === 2) {
                        const newDist = this.getTouchDist(e.touches);
                        const diff = newDist / startDist;
                        this.scale = Math.min(Math.max(this.scale * diff, 0.8), 3); // Limita el zoom
                        startDist = newDist;
                    }
                });
            }
        }
    }

    getTouchDist(touches: TouchList) {
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    zoomIn() {
        this.scale = Math.min(this.scale + 0.2, 3);
    }

    zoomOut() {
        this.scale = Math.max(this.scale - 0.2, 0.8);
    }


    async sharePreviewPdf() {
        try {
            if (!this.previewFileUrl || !this.previewFileName) {
                this.$modal.show("dialog", { title: "WaitingMed", text: "No file available to share." });
                return;
            }

            const response = await fetch(this.previewFileUrl);
            const data = await response.blob();
            const blob = new Blob([data], { type: 'application/pdf' });
            const filename = this.previewFileName;
            const file = new File([blob], filename, { type: blob.type });

            const nav = navigator as NavigatorShare;

            if (nav.canShare?.({ files: [file] })) {
                await (nav.share as NonNullable<NavigatorShare["share"]>)({
                    title: "Laboratory results",
                    text: "I’m sharing my results with you:",
                    files: [file],
                });
            } else {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                URL.revokeObjectURL(link.href);
            }
        } catch (err) {
            console.error('Error sharing PDF from preview:', err);
            //this.$modal.show("dialog", { title: "WaitingMed", text: "An error occurred while sharing." });
        }
    }

    async shareFile(result: any) {
        try {
            this.$set(result, 'sharing', true);
            const url = '/labs/download';
            const form = new FormData();
            form.append('storageId', result.StorageID);

            const resp = await Vue.axios.post(url, form, { responseType: 'blob' });
            const blob = new Blob([resp.data], { type: 'application/pdf' });
            const filename = result.FileName || 'archivo.pdf';
            const file = new File([blob], filename, { type: blob.type });

            const nav = navigator as NavigatorShare;

            if (nav.canShare?.({ files: [file] })) {
                await (nav.share as NonNullable<NavigatorShare["share"]>)({
                    title: "Laboratory results",
                    text: "I’m sharing my result with you:",
                    files: [file],
                });
                //this.$set(result, 'downloaded', true);
            } else {
                // Fallback: descarga local
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                URL.revokeObjectURL(link.href);
                //this.$set(result, 'downloaded', true);
            }
        } catch (err) {
            console.error('Error sharing PDF:', err);
            //this.$modal.show("dialog", { title: "WaitingMed", text: "An error occurred while sharing." });
        } finally {
            this.$set(result, 'sharing', false);
        }
    }

    

    mounted() {

        this.initPreviewZoom();
        /*
        const visitFromRoute = this.$route.params.visit;
        if (visitFromRoute) {
            this.internalVisit = visitFromRoute;
            sessionStorage.setItem("visitData", JSON.stringify(visitFromRoute));
        } else {
            const visitFromStorage = sessionStorage.getItem("visitData");
            if (visitFromStorage) {
                this.internalVisit = JSON.parse(visitFromStorage);
                if (this.internalVisit.header.PublicID != this.publicId) {
                    sessionStorage.removeItem("visitData");
                    this.$router.replace({ name: "LabLogin" });
                }
            } else {
                this.$router.replace({ name: "LabLogin" });
                return;
            }
        }
*/
        const configData = sessionStorage.getItem("themeConfig");
        if (configData) {
            this.themeConfig = JSON.parse(configData);
            applyTheme(this.themeConfig);
        }


        this.initData();
        this.$i18n.locale = this.$store.state.main.lang || "en";
        this.getEntityLogo();
    }
}
